import React from 'react';
import {connect} from 'react-redux';
import CurrencyInput from 'components/forms/BasicFormFields/CurrencyInput';
import {CurrenciesByLanguage} from 'utils/DBUtils';

const RetailerItemCurrencyInput = connect((state, ownProps) => {
  const {selectedLang} = state.rewards;
  const currency = CurrenciesByLanguage[selectedLang];

  return {
    currency,
    valueDataType: 'string' // the API expects floats represented as strings
  };
})(CurrencyInput);

export default RetailerItemCurrencyInput;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RetailerItemModal/RetailerItemCurrencyInput.jsx